import { GetMemberByIdResponse } from '@/modules/manage-member/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getMemberById } from '../../services'
import { OperatorQueryKeys } from '@/modules/manage-member/keys'

export default function useQueryGetMemberById(
	id: string,
	props?: UseBaseQueryOptions<GetMemberByIdResponse>,
) {
	return useQuery({
		queryKey: [OperatorQueryKeys.GetMemberById, id],
		queryFn: () => getMemberById(id),
		...props,
	})
}
